import { TankerTruckIcon } from './TankerTruckIcon';

/**
 * author: Michael Irigoyen
 * id E7134093-7DFD-48A0-A687-299B70E6D42D
 * name tanker-truck
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tanker-truck.svg
 * tags
 * - Transportation + Road 
 */
export const WaterTruckIcon = TankerTruckIcon;
export default WaterTruckIcon